// removed by extract-text-webpack-plugin
module.exports = {"container":"avatar__container__3pS07","avatar":"avatar__avatar__1YFKI","fauxAvatar":"avatar__fauxAvatar__3l01I avatar__avatar__1YFKI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/avatar.scss
// module id = 1185
// module chunks = 1